import { ReactNode, useState } from 'react';

import { Button, Flex, Heading, Grid, GridItem } from '@chakra-ui/react';

import Card from 'components/card/Card';

import ValidationItem from 'views/validated_policy/components/ValidationItem';

const caution = '#ffda87';
const fail = '#f8a586';
const pass = '#badeb5';

const ValidationsSummary = ({
  validations,
  footer,
}: {
  validations: Validation[];
  footer?: ReactNode;
}) => {
  const [filterType, setFilterType] = useState<string | null>(null);

  const clickFilter = (type: string) => {
    setFilterType(type === filterType ? null : type);
  };

  const sortValidations = (vals: Validation[] = []) => {
    const sortedValidations = [...vals].sort((a, b) => {
      const outcomeOrder: Record<string, number> = {
        fail: 0,
        caution: 1,
        pass: 2,
      };

      return (
        outcomeOrder[a.validation_outcome] - outcomeOrder[b.validation_outcome]
      );
    });

    if (filterType && filterType !== 'all') {
      return sortedValidations.filter(
        (v) => v.validation_outcome === filterType,
      );
    }

    return sortedValidations;
  };

  const sortedValidations = sortValidations(validations);

  const numPass = validations.filter(
    (v) => v.validation_outcome === 'pass',
  ).length;
  const numCaution = validations.filter(
    (v) => v.validation_outcome === 'caution',
  ).length;
  const numFail = validations.filter(
    (v) => v.validation_outcome === 'fail',
  ).length;

  return (
    <>
      <Card>
        <Heading
          size="lg"
          textAlign="center"
          mb={{ base: '16px', md: '20px' }}
          color="#59606A"
        >
          Summary View
        </Heading>

        <Flex
          justifyContent="space-evenly"
          flexDir={{ base: 'column', sm: 'row' }}
          alignItems="center"
          gap={{ base: 4, sm: 2 }}
        >
          <Button
            onClick={() => clickFilter('pass')}
            color="#59606A"
            textAlign="center"
            padding={{ base: '3rem', md: '4rem' }}
            w={{ base: '60%', sm: '3rem' }}
            background={pass}
            borderRadius="50%"
            variant={filterType === 'pass' ? 'solid' : 'outline'}
            border={filterType === 'pass' ? '1px solid #59606A' : undefined}
          >
            {numPass} Pass
          </Button>
          <Button
            onClick={() => clickFilter('caution')}
            color="#59606A"
            textAlign="center"
            padding={{ base: '3rem', md: '4rem' }}
            w={{ base: '60%', sm: '3rem' }}
            background={caution}
            borderRadius="50%"
            variant={filterType === 'caution' ? 'solid' : 'outline'}
            border={filterType === 'caution' ? '1px solid #59606A' : undefined}
          >
            {numCaution} Caution
          </Button>
          <Button
            onClick={() => clickFilter('fail')}
            color="#59606A"
            textAlign="center"
            padding={{ base: '3rem', md: '4rem' }}
            w={{ base: '60%', sm: '3rem' }}
            background={fail}
            borderRadius="50%"
            variant={filterType === 'fail' ? 'solid' : 'outline'}
            border={filterType === 'fail' ? '1px solid #59606A' : undefined}
          >
            {numFail} Fail
          </Button>
        </Flex>
      </Card>

      <Card w="100%" mt="20px" alignSelf="center" mb="20px">
        <Grid
          templateColumns={{
            base: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          }}
          gap="20px"
        >
          {sortedValidations.map((validation) => (
            <GridItem key={validation.validation_id}>
              <ValidationItem validation={validation} />
            </GridItem>
          ))}
        </Grid>

        {footer}
      </Card>
    </>
  );
};

export default ValidationsSummary;
